'use client';

import { useQuery } from '@tanstack/react-query';
import {
  getAdminReferralDetail,
  getAdminReferralStats,
  listAdminReferrals,
  type AdminReferralsListParams,
} from '@nomiss/services';

export const adminReferralsQueryKeys = {
  all: ['admin', 'referrals'] as const,
  list: (filters: AdminReferralsListParams) =>
    [...adminReferralsQueryKeys.all, 'list', filters] as const,
  stats: () => [...adminReferralsQueryKeys.all, 'stats'] as const,
  detail: (id: string) =>
    [...adminReferralsQueryKeys.all, 'detail', id] as const,
};

export function useAdminReferralsList(filters: AdminReferralsListParams) {
  const adminReferralsListQuery = useQuery({
    queryKey: adminReferralsQueryKeys.list(filters),
    queryFn: () => listAdminReferrals(filters),
  });

  return { adminReferralsListQuery };
}

export function useAdminReferralStats() {
  const adminReferralStatsQuery = useQuery({
    queryKey: adminReferralsQueryKeys.stats(),
    queryFn: () => getAdminReferralStats(),
  });

  return { adminReferralStatsQuery };
}

export function useAdminReferralDetail(id: string | undefined) {
  const adminReferralDetailQuery = useQuery({
    queryKey: adminReferralsQueryKeys.detail(id ?? ''),
    queryFn: () => getAdminReferralDetail(id!),
    enabled: Boolean(id),
  });

  return { adminReferralDetailQuery };
}
